import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import AlertMsg from '../AlertMsg';
import config from '../../api/config.json';
import api from '../../api';

const ModalChangeImage = props => {
  const { handleModalClose, showModal, user, title } = props;
  const INITIAL_VALUES = {
    user: '',
    image: ''
  };
  const handleExited = () => {
    setData({ ...INITIAL_VALUES });
  };
  const [data, setData] = useState(INITIAL_VALUES);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const handleChangeImage = evt => {
    const { files } = evt.target;
    const suportedTypes = ['image/png', 'image/jpeg'];
    files[0] && suportedTypes.includes(files[0].type)
      ? setData({ ...data, user, image: files[0] })
      : setData({ ...data, user, image: '' });
  };

  const handleSubmit = async () => {
    try {
      setIsFetching(true);
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        formData.append(key, data[key]);
      });
      await api().post('/api/users/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setIsSuccess(true);
    } catch (err) {
      console.error(err);
      setIsError(true);
    } finally {
      setTimeout(() => {
        setIsFetching(false);
        setIsSuccess(false);
        setIsError(false);
      }, 5000);
    }
  };

  return (
    <React.Fragment>
      <Modal
        show={showModal}
        onHide={handleModalClose}
        onExited={handleExited}
        animation={true}
      >
        <Modal.Body>
          {!isSuccess && !isError && (
            <AlertMsg
              type="info"
              msg="Área alteração da imagem do perfil após mudanças recarregue a página"
            />
          )}
          {isSuccess && !isError && isFetching && (
            <AlertMsg
              type="success"
              msg="Imagem alterada com sucesso para ver as mudanças imediatamente recarregue a página"
            />
          )}
          {isError && !isSuccess && isFetching && (
            <AlertMsg
              type="danger"
              msg="Falha durante alteração da imagem do perfil tente novamente"
            />
          )}
          <div>
            <div className="change-image-pic mt-2">
              <img
                className="img-responsive"
                src={
                  data.image
                    ? URL.createObjectURL(data.image)
                    : `${config.protocol}://${config.ipServerGW}:${
                        config.portServerGW
                      }/api/users/image/${user}?key=${Date.now().toString()}`
                }
                alt="Avatar"
              />
            </div>
            <div className="text-center font-weight-bold">
              <p className="m-0">{title}</p>
            </div>
            <div className="form-group">
              <label htmlFor="image">Nova Imagem</label>
              <input
                type="file"
                id="image"
                name="image"
                className="form-control-file"
                accept="image/png,image/jpeg"
                onChange={handleChangeImage}
              />
            </div>
            <div className="mt-1">
              <Button variant="secondary" onClick={handleModalClose}>
                <i className="fa fa-times"></i>
                &nbsp;Fechar
              </Button>
              <Button
                type="button"
                className="float-right"
                variant="primary"
                disabled={isFetching || !data.image}
                onClick={handleSubmit}
              >
                <i className="fa fa-save"></i>
                &nbsp;Salvar
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalChangeImage.propTypes = {
  handleModalClose: PropTypes.func,
  showModal: PropTypes.bool,
  user: PropTypes.string,
  title: PropTypes.string
};

export default ModalChangeImage;
